import { configureClient } from '@column/api';

import { API_URL } from '~/constants';
import { useSessionStore } from '~/stores/Session';

configureClient({
  baseUrl: API_URL,
  getSessionContext: () => {
    const state = useSessionStore.getState();
    return {
      platformId: state.currentPlatform?.id ?? state.currentUser?.defaultPlatformId ?? '',
      liveMode: !state.isSandbox,
    };
  },
});
